import { useEffect, useState } from "react";
import styles from "./Home.module.css";
import { getTokenInfo, logOut } from "../../../utils/Guard";
import { Divider } from "primereact/divider";
import ABALogo from "../../../assets/img/ABAColor.png";
import Loading from "../../../components/UI/loading/Loading";

const Home = () => {

    const userInfo = getTokenInfo();
    const [isLoading, setIsLoading] = useState(true);
    const [showEconomicSituationOptions, setshowEconomicSituationOptions] = useState(false);
    const [showEconomicCycleOptions, setshowEconomicCycleOptions] = useState(false);
    const [showTrustIndexOptions, setShowTrustIndexOptions] = useState(false);
    
    useEffect(() => {
        if (
            userInfo === undefined ||
            userInfo === null ||
            userInfo.id === undefined ||
            userInfo.id === null ||
            userInfo.id === ""
        ) {
            window.location.href = "/login";
        } else {
            setTimeout(() => {
                setIsLoading(false);
            }, 1000);
        }
    }, [userInfo]);

  const signOut = () => {
    logOut();
    setIsLoading(true);

    setTimeout(() => {
      window.location.href = "/login";
    }, 2000);
  };

  const goToDashboard = (id) => {
    window.location.href = "/dashboard/" + id;
  };

  if (isLoading) {
    return <Loading />;
  }

  if (!isLoading) {
    return (
      <>
        <div className="flex justify-content-between items-center w-full px-5 py-2">
          <img
            src={ABALogo}
            alt="ABA Logo"
            className={`${styles.logo} w-full`}
          />
          <button
            onClick={() => signOut()}
            className={`${styles.logoutButton} pi pi-sign-out`}
          ></button>
        </div>
        <h1 className={styles.menuTitle}>Bienvenido al DataLab</h1>
        <h2 className={styles.menuSubtitle}>
          Consulte los datos económicos actuales con nuestros paneles diseñados
          con la industria financiera en mente.
        </h2>

        <div className={`grid py-0 m-0 ${styles.menuContainer}`}>
          <div className="col-4 p-0 h-full">
            <div className={`h-full flex ${styles.optionBox}`}>
              <div className="flex flex-column w-full">
                <div
                  className={`w-full flex pt-4 pl-6 pb-3 pr-6 ${styles.optionBoxHeader}`}
                >
                  <i className={`pi pi-chart-scatter ${styles.optionIcon}`}></i>
                  <h2 className={styles.optionTitle}>Reportes diarios</h2>
                </div>
                <Divider className="mt-0" />
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(1)}
                >
                  Precios y liquidez
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(8)}
                >
                  Tasas de interés
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(9)}
                >
                  Overnight
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(10)}
                >
                  Tipo de cambio
                </div>
              </div>
            </div>
          </div>
          <Divider layout="vertical" className="m-0" />
          <div className="col-4 p-0 h-full">
            <div className={`h-full flex ${styles.optionBox}`}>
              <div className="flex flex-column w-full">
                <div
                  className={`w-full flex pt-4 pl-6 pb-3 pr-6 ${styles.optionBoxHeader}`}
                >
                  <i className={`pi pi-chart-line ${styles.optionIcon}`}></i>
                  <h2 className={styles.optionTitle}>Reportes mensuales</h2>
                </div>
                <Divider className="mt-0" />
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(11)}
                >
                  Actividad económica
                </div>
                <div
                  className={`${styles.reportItem}`}
                  style={{
                    borderBottom: showEconomicSituationOptions
                      ? "2px solid #1a2a49"
                      : "2px solid transparent",
                  }}
                  onClick={() =>
                    setshowEconomicSituationOptions(
                      !showEconomicSituationOptions
                    )
                  }
                >
                  Coyuntura económica
                </div>
                <div
                  className={`${styles.reportSubContainer} ${
                    showEconomicSituationOptions ? styles.show : ""
                  }`}
                >
                  <div
                    onClick={() => goToDashboard(23)}
                    className={`${styles.reportSubItem}`}
                  >
                    Dashboard
                  </div>
                  <div
                    onClick={() =>
                      (window.location.href =
                        "https://registropagosapiprod.azurewebsites.net/admin/datalab/downloadreport/ce")
                    }
                    className={`${styles.reportSubItem}`}
                  >
                    Análisis completo (PDF)
                  </div>
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(12)}
                >
                  Inflación y política monetaria
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(13)}
                >
                  Crédito bancario (Banco central)
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(14)}
                >
                  Crédito bancario (SB)
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(21)}
                >
                  Balances e indicadores bancarios
                </div>
              </div>
            </div>
          </div>
          <Divider layout="vertical" className="m-0" />
          <div className="col-4 p-0 h-full">
            <div className={`h-full flex ${styles.optionBox}`}>
              <div className="flex flex-column w-full">
                <div
                  className={`w-full flex pt-4 pl-6 pb-3   pr-6 ${styles.optionBoxHeader}`}
                >
                  <i className={`pi pi-chart-bar ${styles.optionIcon}`}></i>
                  <h2 className={styles.optionTitle}>Reportes trimestrales</h2>
                </div>
                <Divider className="mt-0" />
                <div
                  className={`${styles.reportItem}`}
                  style={{
                    borderBottom: showEconomicCycleOptions
                      ? "2px solid #1a2a49"
                      : "2px solid transparent",
                  }}
                  onClick={() => goToDashboard(16)}
                  //   onClick={() =>
                  //     setshowEconomicCycleOptions(!showEconomicCycleOptions)
                  //   }
                >
                  Ciclo económico y proyecciones
                </div>
                {/* <div className={`${styles.reportSubContainer} ${showEconomicCycleOptions ? styles.show : ''}`}>
                                    <div onClick={() => goToDashboard(16)} className={`${styles.reportSubItem}`}>Dashboard</div>
                                    <div onClick={() => window.location.href = "https://registropagosapiprod.azurewebsites.net/admin/datalab/downloadreport/cep"} className={`${styles.reportSubItem}`}>Análisis completo (PDF)</div>
                                </div> */}
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(20)}
                >
                  PIB Sectorial
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(18)}
                >
                  Demanda interna
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() => goToDashboard(19)}
                >
                  Mercado laboral
                </div>
                <div
                  className={`${styles.reportItem}`}
                  onClick={() =>
                    setShowTrustIndexOptions(!showTrustIndexOptions)
                  }
                  style={{
                    borderBottom: showTrustIndexOptions
                      ? "2px solid #1a2a49"
                      : "2px solid transparent",
                  }}
                >
                  Índice de confianza y de crédito
                </div>
                <div
                  className={`${styles.reportSubContainer} ${
                    showTrustIndexOptions ? styles.show : ""
                  }`}
                >
                  <div
                    onClick={() => goToDashboard(22)}
                    className={`${styles.reportSubItem}`}
                  >
                    Dashboard
                  </div>
                  <div
                    className={`${styles.reportSubItem}`}
                    onClick={() =>
                      (window.location.href =
                        "https://registropagosapiprod.azurewebsites.net/admin/datalab/downloadreport/icc")
                    }
                  >
                    Análisis completo (PDF)
                  </div>
                </div>
                <div
                  onClick={() =>
                    (window.location.href =
                      "https://registropagosapiprod.azurewebsites.net/admin/datalab/downloadreport/isb")
                  }
                  className={`${styles.reportItem}`}
                >
                  Informe del sector bancario (PDF)
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default Home;
